import eight from '../assets/svg/projects/eight.svg'
import five from '../assets/svg/projects/five.svg'
import four from '../assets/svg/projects/four.svg'
import one from '../assets/svg/projects/one.svg'
import seven from '../assets/svg/projects/seven.svg'
import six from '../assets/svg/projects/six.svg'
import three from '../assets/svg/projects/three.svg'
import two from '../assets/svg/projects/two.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'mess app',
        projectDesc: 'A full-flexed based mobile application developed for mess management system.',
        tags: ['React js', 'firebase', 'flutter','node js','mongodb'],
        code: 'https://github.com/yashdesai28/messapp',
        // demo: 'https://www.aylanetworks.com/',
        image: six
    },
    {
        id: 2,
        projectName: 'online fruit & vegitable asp.net ',
        projectDesc: 'A project that is developed in ASP.net and can be used as an e-commerce website of managing fruit & vegetable store by automating the system of buying and selling of food products and storing data securely.',
        tags: ['Asp.net', 'sql server', 'html','css','javascript'],
        code: 'https://github.com/yashdesai28/asp.net_fruits',
        // demo: 'https://pandora-web.netlify.app/',
        image: seven
    },
    {
        id: 3,
        projectName: 'cab compare',
        projectDesc: 'This project helps user to compare rates of different cab facilities and book accordinly as per the user convinence.',
        tags: ['flutter'],
        code: 'https://github.com/yashdesai28/cab',
        // demo: 'https://travel-agency-fc58b.web.app/',
        image: eight
    },
    {
        id: 4,
        projectName: 'digital-image-processing',
        projectDesc: 'This can help you clear the basic concepts of digital-image processing such as segmentation,word-count,erosion,dilation,etc. ',
        tags: ['python', 'open cv'],
        code: 'https://github.com/yashdesai28/digital-image-processing',
        // demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: four
    },
    {
        id: 5,
        projectName: 'online fruit & vegitable php',
        projectDesc: 'A project that is developed in PHP and can be used as an e-commerce website of managing fruit & vegetable store by automating the system of buying and selling of food products and storing data securely.',
        tags: ['php', 'sql','html','css','javascript'],
        code: 'https://github.com/yashdesai28/php_project',
        // demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: five
    },

    {
        id: 6,
        projectName: 'mess admin penal ',
        projectDesc: 'This project is developed in flutter for mess handler panel,students panel of mess management system and gives a computerized solution to problems faced in maintaining mess.',
        tags: ['React js', 'html', 'Bootstrap','css','node js'],
        code: 'https://github.com/yashdesai28/mess',
        // demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: two
    },
    {
        id: 7,
        projectName: 'wallpaper app',
        projectDesc: 'A project that is developed in android and can be used as an change wallpaper and search wallpaper ',
        tags: ['Flutter', 'React'],
        code: 'https://github.com/yashdesai28/Android',
        // demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: three
    },
    {
        id: 8,
        projectName: ' bank application java',
        projectDesc: 'TA console based java application which covers all basic functional requirements of bank management system.',
        tags: ['java'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        // demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: one
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/